import { api } from '@/apis';
import { log } from '@/utils';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useRetention(id) {
  const queryKey = ['retentions', id];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: async ({ signal }) => {
      const json = [
        { $match: { identifier: id } },
        {
          $lookup: {
            from: 'vehicles',
            localField: 'imei',
            foreignField: 'telematicsBoxImei',
            as: 'vehicle',
          },
        },
        { $set: { vehicle: { $first: '$vehicle' } } },
        {
          $project: {
            identifier: true,
            imei: true,
            startTime: true,
            endTime: true,
            notes: true,
            vehicle: {
              identificationNumber: true,
              registrationNumber: true,
              fleetNumber: true,
              groups: true,
              role: true,
              type: true,
            },
          },
        },
      ];

      const retentions = await api
        .post('pipeline/telematicsBoxRetentions', { json, signal })
        .json();

      log('Read', 'Data Retentions', { id });

      return retentions[0] ?? null;
    },
    staleTime: 1000 * 60 * 60,
    enabled: !!id && id !== 'new',
  });

  return {
    query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
